import React, { FC, memo } from "react";
import { ComparisonNudgeComms, ComparisonNudgeItem } from "@swiggy-private/cart-types";

// Components
import PlanCard from "../PlanCard";

// Types
import { SubscriptionRenewalAnalytics, SubscriptionRenewalHandlers } from "../../types";

// Constants
import { CONSTANTS, SUBSCRIPTION_RENEWAL_NUDGE_TEST_IDS } from "../../constants";

// Styled Components
import { Container, HeaderText, PlansContainer } from "./styles";
import { isEmpty } from "@swiggy-private/core-ui";

export interface SubscriptionRenewalNudgeWidgetProps {
    comparisonNudgeComms?: ComparisonNudgeComms;
    handlers: SubscriptionRenewalHandlers;
    analyticsEvents?: SubscriptionRenewalAnalytics;
    setShowRemovePlanConfirmation?: (value: boolean) => void;
    isTopPositioned: boolean;
}

const SubscriptionRenewalNudgeWidget: FC<SubscriptionRenewalNudgeWidgetProps> = ({
    comparisonNudgeComms,
    handlers,
    analyticsEvents,
    setShowRemovePlanConfirmation,
    isTopPositioned,
}) => {
    const nudges = comparisonNudgeComms?.nudges || [];

    if (isEmpty(comparisonNudgeComms) || isEmpty(nudges)) {
        return null;
    }

    const headerText = comparisonNudgeComms?.header;

    return (
        <Container data-testid={SUBSCRIPTION_RENEWAL_NUDGE_TEST_IDS.CONTAINER} isTopPositioned={isTopPositioned}>
            {headerText && (
                <HeaderText
                    variant="V2.overline.neutral.medium"
                    color="text_Med_Emphasis"
                    data-testid={SUBSCRIPTION_RENEWAL_NUDGE_TEST_IDS.HEADER}
                    role="heading"
                    aria-level={3}
                >
                    {headerText}
                </HeaderText>
            )}

            <PlansContainer
                data-testid={SUBSCRIPTION_RENEWAL_NUDGE_TEST_IDS.PLANS_CONTAINER}
                aria-label={CONSTANTS.PLANS_CONTAINER_ARIA_LABEL}
            >
                {nudges.map((planData: ComparisonNudgeItem, index: number) => (
                    <PlanCard
                        key={`${planData.plan_details.plan_id || index}`}
                        planData={planData}
                        index={index}
                        handlers={handlers}
                        analyticsEvents={analyticsEvents}
                        setShowRemovePlanConfirmation={setShowRemovePlanConfirmation}
                    />
                ))}
            </PlansContainer>
        </Container>
    );
};

export default memo(SubscriptionRenewalNudgeWidget);
